module.exports = __webpack_public_path__ + "img/check-circle.ca5df8bc.svg";